import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center font-mono text-[10px] tracking-wider px-1.5 py-0.5',
  {
    variants: {
      variant: {
        alert: 'bg-alert text-surface-raised',
        neutral: 'bg-ink text-surface-raised',
        outline: 'border border-line-bold text-ink-muted',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

export type BadgeProps = ComponentProps<'span'> & VariantProps<typeof badgeVariants>;

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
